import { RequestType } from 'commons/types'

export interface WebPageRequest {
  type: RequestType
  url: string
  body?: any
}
